import React from "react"
export function ColdDrinks(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M4.998 5.004h.46l1.056 12.5h5.707l.984-11.5H8.679v-1h5.07l.085.008a.5.5 0 01.412.449v.086l-1.069 12.5-.014.084a.5.5 0 01-.4.366l-.084.007H6.054l-.085-.007a.5.5 0 01-.4-.367l-.013-.084L4.5 5.546V5.46a.5.5 0 01.412-.449l.086-.007zM2.63 1.5l3.622 1.485a.5.5 0 01.244.214l.036.075 4.628 12.515-.938.347-4.553-12.31-3.418-1.4.38-.926zm12.621 0A2.752 2.752 0 0118 4.253a2.752 2.752 0 01-2.582 2.749l-.168.005v-1c.966 0 1.75-.785 1.75-1.754 0-.968-.784-1.753-1.75-1.753-.918 0-1.671.708-1.744 1.61l-.006.143h-1A2.752 2.752 0 0115.25 1.5z"
        fill="currentColor"
        fillRule="nonzero"
        id="prefix__cold-drinks"
        stroke="none"
        strokeWidth={1}
      />
    </svg>
  )
}
